import { ClientError } from '@tribeplatform/gql-client/lib'
import {
  PaginatedPost,
  QuerySearchPostsArgs,
} from '@tribeplatform/gql-client/types'
import { PaginatedPostFields } from '@tribeplatform/gql-client/types/generated'
import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  useTribeClient,
} from '@tribeplatform/react-sdk'
import { getInfiniteSearchPostsKey } from '@tribeplatform/react-sdk/utils/keys'

type Props = {
  variables: QuerySearchPostsArgs
  fields?: PaginatedPostFields
  useInfiniteQueryOptions?: UseInfiniteQueryOptions<PaginatedPost>
}

export const useInfiniteSearchPosts = ({
  variables,
  fields,
  useInfiniteQueryOptions,
}: Props) => {
  const { client } = useTribeClient()

  return useInfiniteQuery<PaginatedPost, ClientError>(
    getInfiniteSearchPostsKey({ variables, fields }),
    ({ pageParam: after }) =>
      client.searchPosts({ after, ...variables }, fields),
    {
      refetchOnWindowFocus: false,
      ...useInfiniteQueryOptions,
    },
  )
}
